import { Schema } from 'firebase/ai';
import { arraySchema, objectSchema } from './schemaBuilders.js';

export const recommendationSchema = objectSchema({
  projects: arraySchema(
    objectSchema({
      title: Schema.string(),
      overview: Schema.string(),
      why: Schema.string(),
      steps: arraySchema(Schema.string()),
      outcome: Schema.string(),
    })
  ),
  skills: arraySchema(
    objectSchema({
      name: Schema.string(),
      description: Schema.string(),
      why: Schema.string(),
    })
  ),
});

export const projectRewriteSchema = objectSchema({
  title: Schema.string(),
  overview: Schema.string(),
  images: arraySchema(
    objectSchema({
      imageId: Schema.string(),
      description: Schema.string(),
    })
  ),
});

export const skillRewriteSchema = objectSchema({
  name: Schema.string(),
  description: Schema.string(),
});
